const phylanAns = [
  {
    id: 0,
    question: "1. What is Philanthropy by Ballers?",
    answer: (
      <div>
        <p>
          Ballers Philanthropy is our initiative that allows individuals and
          organizations to donate to promising athletes and sports teams. Your
          contributions help them overcome financial barriers and achieve their
          full potential.
        </p>
      </div>
    ),
  },
  {
    id: 1,
    question: "2. How does my donation make a difference?",
    answer: (
      <div>
        <p>
          Your donation directly supports athletes who lack the resources needed
          to compete at the highest levels. Whether it's covering training
          costs, travel expenses, or essential equipment, your contribution
          plays a crucial role in their journey to success.
        </p>
      </div>
    ),
  },
  {
    id: 2,
    question: "3. Can I choose which athlete or team to support?",
    answer: (
      <div>
        <p>
          Yes! We provide a curated list of athletes and sports initiatives that
          need support. You can choose the cause that resonates with you and
          make a targeted donation.
        </p>
      </div>
    ),
  },
  {
    id: 3,
    question: "4. How do I know my donation is going to the right place?",
    answer: (
      <div>
        <p>
          We conduct thorough vetting and due diligence to ensure that your
          donations go to deserving athletes and teams. We maintain transparency
          throughout the process, so you know exactly where your money is going.
        </p>
      </div>
    ),
  },
  {
    id: 4,
    question: "5. Will I receive updates on the athlete I support?",
    answer: (
      <div>
        <p>
          Absolutely! Ballers Philanthropy keeps you connected with regular
          updates on the progress and achievements of the athletes and teams you
          support. You’ll see firsthand the impact of your generosity.
        </p>
      </div>
    ),
  },
  {
    id: 5,
    question: "6.  Is there a minimum amount I need to donate?",
    answer: (
      <div>
        <p>
          There’s no minimum donation amount. Whether you’re giving a little or
          a lot, every contribution helps athletes pursue their dreams.
        </p>
      </div>
    ),
  },
  {
    id: 6,
    question: "7.  Can organizations and companies participate?",
    answer: (
      <div>
        <p>
          Yes, companies and organizations can also take part in Ballers
          Philanthropy. Whether as part of a corporate social responsibility
          initiative or a standalone contribution, your support is invaluable.
        </p>
      </div>
    ),
  },
  {
    id: 7,
    question: "8.  How can I get involved beyond donating?",
    answer: (
      <div>
        <p>
          In addition to donating, you can share the stories of the athletes and
          teams you support, helping to raise awareness and inspire others to
          contribute.
        </p>
      </div>
    ),
  },
  {
    id: 8,
    question: "9. Is my donation tax-deductible?",
    answer: (
      <div>
        <p>
          Depending on your location and local tax laws, your donation may be
          tax-deductible. We recommend consulting with a tax advisor to
          determine your eligibility.
        </p>
      </div>
    ),
  },
  {
    id: 9,
    question: "10. How do I get started?",
    answer: (
      <div>
        <p>
          It’s simple! Browse through our list of athletes and initiatives,
          choose the cause that resonates with you, and make your donation. From
          there, you’ll receive updates on how your contribution is making a
          difference.
        </p>
      </div>
    ),
  },
];

export default phylanAns;
